import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Register from "./register";
import ManagedParty from "./managedParty";
import { AccountContext } from "../accountContext";

const useStyles = makeStyles((theme) => ({
  registerTicket: {},
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginBottom: "16px",
    marginTop: ".5rem",
  },
}));

const Ticket = (props) => {
  const classes = useStyles();
  const accountContext = useContext(AccountContext);
  const { isSelf, activePersonId } = accountContext.state;
  const language = useSelector((state) => state.language);
  return (
    <div className={classes.registerTicket}>
      <Typography variant="h1">{language.Pages["register ticket"]}</Typography>
      <Typography className={classes.pageInfo}>
        {language.PageInfo["register ticket"]}
      </Typography>
      {isSelf ? <Register /> : <ManagedParty activePersonId={activePersonId} />}
    </div>
  );
};

export default Ticket;
